import React from "react";
import Image from "next/image";
import SwiperCore, { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/scrollbar";
import { Swiper, SwiperSlide } from "swiper/react";
import banner from "@/assets/images/banner-h.jpg";
import styles from "@/styles/houseOfSenco.module.scss";

const Banner = () => {
  return (
    <div className="house-senco">
      <div className={styles.banner_slide}>
        <Swiper pagination={true} modules={[Pagination]} className="mySwiper">
          <SwiperSlide>
            <div className={styles.image}>
              <Image src={banner} alt="" />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default Banner;
